import React from "react";
import { Typography, Link } from "@material-ui/core";

const NotAvailable = () => {
  return (
    <div className="not-found">
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`}
        alt="logo"
      />
      <Typography variant="h4" gutterBottom>
        La tienda que estás buscando no está disponible.
      </Typography>
      <Typography variant="h5" gutterBottom>
        Ante cualquier duda, consúltanos a{" "}
        <Link href="mailto:hola@carritofacil.cl">hola@carritofacil.cl</Link>
      </Typography>
    </div>
  );
};

export default NotAvailable;
